module.exports = __webpack_public_path__ + "static/media/Baby-Girl.d83fec4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Baby-Girl.png
// module id = 443
// module chunks = 0